import { useEffect, useState } from "react";

/**
 * Registers the service worker (production builds) and offers to reload when a new version of
 * the app is available. Data is never affected by an app update: it lives in IndexedDB.
 */
export function UpdatePrompt() {
  const [update, setUpdate] = useState<(() => Promise<void>) | null>(null);
  const [offlineReady, setOfflineReady] = useState(false);
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
    let cancelled = false;
    void import("virtual:pwa-register").then(({ registerSW }) => {
      if (cancelled) return;
      const updateSW = registerSW({
        onNeedRefresh: () => setUpdate(() => () => updateSW(true)),
        onOfflineReady: () => setOfflineReady(true),
      });
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (update) {
    return (
      <div role="status" className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg bg-petrol-soft px-4 py-3 text-sm">
        <span>È disponibile una nuova versione dell&apos;app. I tuoi dati restano sul dispositivo.</span>
        <button
          type="button"
          disabled={updating}
          onClick={() => {
            setUpdating(true);
            void update();
            // The new version normally reloads the page by itself; if a browser never does, reload.
            window.setTimeout(() => window.location.reload(), 6000);
          }}
          className="rounded-lg bg-petrol px-3 py-2 font-semibold text-white disabled:opacity-70"
        >
          {updating ? "Aggiornamento…" : "Aggiorna"}
        </button>
      </div>
    );
  }
  if (offlineReady) {
    return (
      <div role="status" className="mb-4 flex items-center justify-between gap-3 rounded-lg bg-petrol-soft px-4 py-3 text-sm">
        <span>L&apos;app è pronta per funzionare offline.</span>
        <button type="button" onClick={() => setOfflineReady(false)} className="font-semibold text-petrol">
          OK
        </button>
      </div>
    );
  }
  return null;
}
